import { createFileRoute } from "@tanstack/react-router";
import VideosMedia from "@/pages/VideosMedia";
export const Route = createFileRoute("/contents/patient-info/videos-media")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Videos & Media | Neuro Wellness TMS Centers of America",
        },
        {
          name: "description",
          content:
            "Watch SAINT® TMS explainer videos and learn how fMRI-guided accelerated depression treatment works at Neuro Wellness TMS Centers of America in Coral.",
        },
        {
          property: "og:title",
          content: "Videos & Media | Neuro Wellness TMS Centers of America",
        },
        {
          property: "og:description",
          content:
            "Watch SAINT® TMS explainer videos and learn how fMRI-guided accelerated depression treatment works at Neuro Wellness TMS Centers of America in Coral.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/contents/patient-info/videos-media",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/contents/patient-info/videos-media",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <VideosMedia />;
}
